import { create } from 'zustand';
import { MaterialAliasData, MaterialAliasSetData } from '../../../shared/dto/EntityRepository';
import {
  MaterialAliasSortOrder,
  PerPage,
  SortDirection,
} from '../../../shared/enum/EnumRepository';

interface AdminMaterialAliasState {
  aliasList: MaterialAliasData[];
  aliasSetList: MaterialAliasSetData[];
  activeAlias: MaterialAliasData | null;
  page: number;
  totalPages: number;
  pageSize: PerPage;
  unassignedOnly: boolean;
  sortField: MaterialAliasSortOrder;
  sortDirection: SortDirection;
  setAliasList: (aliasList: MaterialAliasData[]) => void;
  setAliasSetList: (aliasSetList: MaterialAliasSetData[]) => void;
  setActiveAlias: (activeAlias: MaterialAliasData | null) => void;
  setPagination: (page: number, totalPages: number) => void;
  setPageSize: (pageSize: PerPage) => void;
  setUnassignedOnly: (unassignedOnly: boolean) => void;
  setSortData: (
    sortField: MaterialAliasSortOrder,
    sortDirection: SortDirection,
  ) => void;
  replaceAlias: (alias: MaterialAliasData) => void;
  removeAlias: (aliasId: string) => void;
}

export const useAdminMaterialAliasStore = create<AdminMaterialAliasState>((set) => ({
  aliasList: [],
  aliasSetList: [],
  activeAlias: null,
  page: 1,
  totalPages: 0,
  pageSize: PerPage.PAGE_10,
  unassignedOnly: true,
  sortField: MaterialAliasSortOrder.FREQUENCY,
  sortDirection: SortDirection.DESC,
  setAliasList: (aliasList) => set({ aliasList }),
  setAliasSetList: (aliasSetList) => set({ aliasSetList }),
  setActiveAlias: (activeAlias) => set({ activeAlias }),
  setPagination: (page, totalPages) => set({ page, totalPages }),
  setPageSize: (pageSize) => set({ pageSize }),
  setUnassignedOnly: (unassignedOnly) => set({ unassignedOnly }),
  setSortData: (sortField, sortDirection) => set({
    sortField,
    sortDirection,
  }),
  replaceAlias: (alias) => set((state) => ({
    aliasList: state.aliasList.map((each) => each.id === alias.id ? alias : each),
    activeAlias: alias,
  })),
  removeAlias: (aliasId) => set((state) => ({
    aliasList: state.aliasList.filter((alias) => alias.id !== aliasId),
    activeAlias: state.activeAlias?.id === aliasId ? null : state.activeAlias,
  })),
}));
